import { TypePolicies } from '@apollo/client';

const PlanCacheTypePolicies: TypePolicies = {
  PlanEntitlement: {
    keyFields: ['key'],
  },
  Query: {
    fields: {
      getPlanDetails: {
        merge: (_existing, incoming) => {
          return incoming;
        },
      },
    },
  },
};

export { PlanCacheTypePolicies };
